import '../../../resources/css/admin_style.css';
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../../utils/loading/Loading";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {IAM_SERVER_TENANT} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import DetailModal from "../../../utils/modal/DetailModal";
import {TenantDetailModal} from "../modal/TenantDetailModal";
import { TableContext } from '../../../utils/contextapi/TableProvider';
import TenantsStatusTable from '../component/TenantsStatusTable';
import { AuthContext } from '../../../utils/contextapi/AuthProvider';
import { getCookie } from '../../../utils/cookies/cookies';

const parseRoles = (roleValue) => {
    if (Array.isArray(roleValue)) {
        return roleValue;
    }

    if (typeof roleValue !== 'string' || !roleValue.trim()) {
        return [];
    }

    try {
        const parsed = JSON.parse(roleValue);
        return Array.isArray(parsed) ? parsed : [parsed].filter(Boolean);
    } catch {
        return roleValue.split(',').map((item) => item.trim()).filter(Boolean);
    }
};


/**
 * 태넌트 승인대기 처리 탭 화면
 * @param props isMobile, searchModel
 */
export const TenantStatusContainer = (props) => {

    const {openModal} = useContext(ModalContext);
    const [loading, setLoading] = useState(false);

    const context = useContext(TableContext);
    const [isMobileWindow, setIsMobileWindow] = useState(false);

    const {
        user,
        role
    } = useContext(AuthContext);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [searchValue, setSearchValue] = useState('');
    const [searchParams, setSearchParams] = useState({ type: '', value: '' });

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        fetchData(searchParams.type, searchParams.value);
    }, [page, context.state.dateRange]);

    // 승인데이터 조회
    const fetchData = async (searchType = '', searchValue = '') => {
        setLoading(true);

        try {
            const url = IAM_SERVER_TENANT + "/all";

            // dateRange 가져오기 (context로부터 최신 상태를 반영)
            const [start, end] = context.state.dateRange;
            const conditions = [
                { field: "status", operator: "IN", value: 'pending,reject' },
            ];

            if (start && end) {
                conditions.unshift(
                    { field: "createdDate", operator: "GREATER_THAN_OR_EQUAL", value: new Date(start).getTime() },
                    { field: "createdDate", operator: "LESS_THAN_OR_EQUAL", value: new Date(end).getTime() }
                );
            }

            // 선택 조건: 검색 조건 있을 때만 추가
            if (searchType.trim() && searchValue.trim()) {
                conditions.push({
                    field: searchType,
                    operator: "LIKE",
                    value: searchValue
                });
            }

            const roles = parseRoles(role);
            const userId = getCookie("user_id");
            
            if(roles.includes("USER")){
                conditions.push(
                    { field: "createdBy", operator: "EQUALS", value: userId }
                );
            }else{

            }

            // 최종 params 구성
            const params = {
                page: page,
                size: listSize,
                sortField: ['createdDate'],
                sortOrder: ['desc'],
                operator: "AND",
                conditions
            };

            const res = await axios.post(url, params);

            const { data, recordsTotal } = res.data.data;

            setTotalCount(recordsTotal);
            setCellData(data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
 
    //검색 조회
    const handleSearch = async (searchType, value) => {
        setSearchParams({ type: searchType, value });
        setSearchValue(value);
        setPage(0);

        if (page === 0) {
            fetchData(searchType, value);
        }
    }

    // 서비스 등록 모달 핸들러
    const onApproval = () => {
    }

    const onReject = () => {
    }

    

    // 서비스 상세정보 모달 핸들러
    const handleDetailInfo = (id) => {
        const modalContent = <TenantDetailModal id={id} update={fetchData}/>
        const modalOption = {modalTitle: '테넌트 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    return (
        <>
            { loading ? <Loading /> :
                <>
                    <TenantsStatusTable
                            datas={cellData}
                            context={context}
                            onReject={onReject}
                            detailTenant={handleDetailInfo}
                            onPageChange={setPage}
                            pageNumber={page}
                            totalCount={totalCount}
                            listSize={listSize}
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            onSearch={handleSearch}
                            isMobileWindow={isMobileWindow}
                        />
                </>
            }
        </>
    )
}
